module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pl-3 pr-3"
  }, [_c('div', {
    staticClass: "col-main"
  }, [_c('div', {
    staticClass: "col-left card"
  }, [_c('div', {
    staticClass: "col-left-top"
  }, [_c('div', {
    staticClass: "float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden-icon",
    on: {
      "click": _vm.shrinkMenu
    }
  }, [_c('i', {
    class: _vm.collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'
  })])]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-vertical",
    attrs: {
      "collapse": _vm.collapse
    }
  }, [_c('div', {
    staticClass: "col-left-panel",
    attrs: {
      "hidden": _vm.collapse
    }
  }, [_c('div', {
    staticClass: "item_head"
  }, [_c('h5', {
    staticClass: "item_h5"
  }, [_vm._v("角色列表")]), _vm._v(" "), _c('el-button', {
    staticClass: "item_btn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dlg_add_role = true
      }
    }
  }, [_vm._v("添加角色")])], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('ul', {
    staticClass: "pl-0 panel_ul"
  }, _vm._l((_vm.roles), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.isActive === index
      },
      attrs: {
        "index": (1 + index).toString()
      },
      on: {
        "click": function($event) {
          return _vm.groupChange(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.remark))]), _vm._v(" "), _c('span', {
      attrs: {
        "stye": "float:right;"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete item_icon",
      on: {
        "click": function($event) {
          return _vm.handleDeleteRole(index, item)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-edit item_icon",
      on: {
        "click": function($event) {
          return _vm.handleEditRole(index, item)
        }
      }
    })])])
  }), 0)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-right"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("权限管理\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('label', {
    staticClass: "item_w"
  }, [_vm._v("角色：")]), _vm._v(" "), _c('label', {
    staticClass: "item_w"
  }, [_vm._v("用户数：" + _vm._s(this.page.total) + "人")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dlg_grant = true
      }
    }
  }, [_vm._v("用户授权\n                ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": _vm.page.size,
      "current-page": _vm.page.index + 1,
      "total": _vm.page.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.users,
      "border": "",
      "highlight-current": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": "团队名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.groupId != 0) ? _c('div', [_vm._v("\n                    " + _vm._s(scope.row.groupName) + "\n                  ")]) : _c('div', [_c('el-tag', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.show_add_group(scope.row)
            }
          }
        }, [_vm._v("添加团队\n                    ")])], 1)]
      }
    }])
  }, [_vm._v("\n                dlg_add_group\n              ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastLogin",
      "label": "最近登录时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatDateTime")(scope.row.lastLogin)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "active",
      "label": "在线",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.active == '1') ? _c('el-button', {
          attrs: {
            "circle": "",
            "type": "info"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.active == null || scope.row.active == 0) ? _c('el-button', {
          attrs: {
            "circle": "",
            "type": "primary"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "角色"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.roles), function(role) {
          return _c('div', [_vm._v("\n                    " + _vm._s(role) + "\n                  ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "启用／停用",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [(scope.row.active == '1') ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row, false)
            }
          }
        }, [_vm._v("停用\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.active == null || scope.row.active == 0) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row, true)
            }
          }
        }, [_vm._v("启用\n                    ")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": _vm.page.size,
      "current-page": _vm.page.index + 1,
      "total": _vm.page.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加角色",
      "visible": _vm.dlg_add_role,
      "close-on-click-modal": false,
      "size": "tiny",
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_add_role = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    staticStyle: {
      "padding-right": "50px"
    },
    attrs: {
      "model": _vm.addForm,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色描述",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "remark", $$v)
      },
      expression: "addForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定添加")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_add_role = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "角色授权",
      "visible": _vm.dlg_grant,
      "close-on-click-modal": false,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_grant = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.search_user
    },
    model: {
      value: (_vm.selectedUserId),
      callback: function($$v) {
        _vm.selectedUserId = $$v
      },
      expression: "selectedUserId"
    }
  }, _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色列表"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['未选', '已选'],
      "props": {
        key: 'name',
        label: 'name'
      },
      "data": _vm.roles
    },
    model: {
      value: (_vm.selectedUser.roles),
      callback: function($$v) {
        _vm.$set(_vm.selectedUser, "roles", $$v)
      },
      expression: "selectedUser.roles"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_grant = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.update_user_role.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8de49e5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sys/Roles.vue
// module id = 287
// module chunks = 1